import type { UseQueryOptions } from '@tanstack/vue-query'

// Common constants
export const STALE_TIME_5_MINUTES = 1000 * 60 * 5

// Exponential backoff retry delay: 1s, 2s, 4s, max 30s
export const retryDelay = (attemptIndex: number) =>
    Math.min(1000 * 2 ** attemptIndex, 30000)

// Default query options for cached API data
export const defaultQueryOptions = {
    staleTime: STALE_TIME_5_MINUTES,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 3,
    retryDelay,
} satisfies Partial<UseQueryOptions<unknown, Error>>

